import React from "react";
import { TableRow, TableData } from "./styledComponents";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

const formatPhoneNumber = (str) => {
  let cleaned = ("" + str).replace(/\D/g, "");
  let matchWithCountryCode = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }

  if (matchWithCountryCode && matchWithCountryCode[1] === "1") {
    return (
      matchWithCountryCode[1] +
      " (" +
      matchWithCountryCode[2] +
      ") " +
      matchWithCountryCode[3] +
      "-" +
      matchWithCountryCode[4]
    );
  }

  return str;
};

const formatDateTime = (str) => {
  return str ? dayjs(str).format("ll") : "";
};

const formatData = (type, data) => {
  var result = data;
  switch (type) {
    case "phone":
      result = formatPhoneNumber(data);
      break;
    case "date":
      result = formatDateTime(data);
      break;
  }

  return result;
};

function RowItem({ columns, data, isEven, isLeadsTable, onRowClick }) {
  const handleRowClick = (e) => {
    // Don't trigger row click if clicking on a link, button, or interactive element
    if (
      e.target.tagName === 'A' ||
      e.target.tagName === 'BUTTON' ||
      e.target.closest('a') ||
      e.target.closest('button') ||
      e.target.closest('[data-no-row-click]')
    ) {
      return;
    }
    if (onRowClick) {
      onRowClick(data);
    }
  };

  // Keyboard path for the row-click shortcut: Enter/Space on the focused row
  // activates it. Only keys aimed at the row itself count — an inner link or
  // button keeps its own native Enter/Space behavior. The <tr> keeps its
  // implicit row role (a button role here would break the table semantics).
  const handleRowKeyDown = (e) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // Space must not scroll the page
      if (onRowClick) onRowClick(data);
    }
  };

  return (
    <TableRow
      isEven={isEven}
      onClick={handleRowClick}
      tabIndex={onRowClick ? 0 : undefined}
      aria-describedby={onRowClick ? "table-row-action-hint" : undefined}
      onKeyDown={onRowClick ? handleRowKeyDown : undefined}
      style={onRowClick ? { cursor: 'pointer' } : undefined}
    >
      {columns.map((c, idx) => {
        const cellData = c.customRow
          ? c.customRow(data)
          : formatData(c.type, data[c.path]);

        return (
          <TableData
            key={idx}
            className={c.className}
            isLeadsTable={isLeadsTable}
            width={c.width ? c.width : undefined}
          >
            {cellData}
          </TableData>
        );
      })}
    </TableRow>
  );
}

export default RowItem;
